export const PAGINATION = {
  curPage: 1,
  limitPage: 10,
  totalRows: 0,
  totalPage: 0
};

export const PAGINATION_PARAMS = {
  offset: 1,
  limit: 10,
  unLimit: 999999
};

export const DEFAULT_PAGINATION_PARAMS = {
  offset: 0,
  limit: 0,
};